import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Box, Text, Image } from 'components/Wrapped';
import { Collapsible } from 'grommet';

import { withNamespaces } from 'react-i18next';
import styles from './CreateOrder.module.scss';

const CommissionPercentageInfo = () => {
  const [open, setOpen] = useState(false);

  return (
    <Box pad="none" className={styles.rootPercInfo}>
      <Box pad="none" direction="row" gap="5px" align="center" style={{ cursor: 'pointer' }} onClick={() => setOpen(!open)}>
        <Image src="/assets/img/icons/percent.svg" />
        <Text color="#777E83" size="12px" weight={600} style={{ lineHeight: '15px' }}>
          Комиссии
        </Text>
      </Box>
      <Box pad="none" style={{ position: 'fixed', bottom: '-5px', left: '-90px' }}>
        <Collapsible open={open} direction="horizontal">
          <Box
            background="rgba(255, 255, 255, 0.03)"
            border={{
              color: '#38444A',
              size: '1px',
              style: 'solid',
              side: 'all',
            }}
            round="16px"
            pad="15px"
            gap="20px"
            width={{ min: '270px' }}
            style={{
              backdropFilter: 'blur(150px)',
              boxShadow: '0px 26px 28px -6px rgba(0, 0, 0, 0.34)',
            }}
          >
            <Box pad="none" direction="row" justify="between" align="center">
              <Text color="white" size="14px" weight={600} style={{ lineHeight: '17px' }}>
                Комиссия
              </Text>
              <Text color="#80C2AD" size="14px" weight={600} style={{ lineHeight: '17px' }}>
                Повышение уровня
              </Text>
            </Box>
            <Box pad="none" direction="row" justify="between" align="center">
              <Box pad="none" direction="row" gap="4px">
                <Text color="#B4B6B7" size="12px" weight={500} style={{ lineHeight: '16px' }}>
                  Мейкер
                </Text>
                <Text color="white" size="14px" weight={600} style={{ lineHeight: '17px' }}>
                  0,08%
                </Text>
              </Box>
              <Box pad="none" direction="row" gap="4px">
                <Text color="#B4B6B7" size="12px" weight={500} style={{ lineHeight: '16px' }}>
                  Тейкер
                </Text>
                <Text color="white" size="14px" weight={600} style={{ lineHeight: '17px' }}>
                  0,150%
                </Text>
              </Box>
            </Box>
          </Box>
        </Collapsible>
      </Box>
    </Box>
  );
};

const mapStateToProps = ({ exchangeSettings }) => ({
  currencySettings: exchangeSettings.currencySettings,
});

export default withNamespaces()(connect(mapStateToProps)(CommissionPercentageInfo));
